import React, { useEffect, useRef } from 'react';
import { Animated, Modal, StyleSheet, TouchableWithoutFeedback, View, Text, TextInput } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import { useDimensions } from 'react-native-web-hooks';
import Game from '../../shell/Game';
import { isMobile } from '../../shell/utils/platformCheck';
import { useAppSelector } from '../../store/hooks';
import { selectInsta, setSelectedImage, setSelectedProfile, setUserName } from '../../store/slices/instaSlice';
import { store } from '../../store/store';
import { RollbackType } from '../Tadvance';
import { InstaImages } from './InstaImages';
import { InstaNavBar } from './InstaNavBar';
import { InstaPost } from './InstaPost';
import { Insta as InstaClass } from './InstaClass';
import { InstaProfile } from './InstaProfile';
import { InstaWelcomeScreen } from './InstaWelcomeScreen';
import { InstaImage, InstaProfileINT } from './interfaces';
import { PromptQuestionModal } from '../PromptQuestionModal';
import { selectMenu } from '../../store/slices/menuSlice';

interface InstaProps {

}

export const Insta: React.FC<InstaProps> = ({ }) => {
    let { width, height } = useDimensions().window;
    const slice = useAppSelector(selectInsta);
    const instaSlice = slice.present;
    const opacity = useRef(new Animated.Value(1));
    // useEffect(() => {
    //     if (instaSlice.display) { return; }
    //     if (Game.rollback === RollbackType.past) {
    //         store.dispatch({ type: "GAME_OBJECT_UNDO" });
    //     }
    //     if (Game.rollback === RollbackType.future) {
    //         store.dispatch({ type: "GAME_OBJECT_REDO" });
    //     }
    // }, [slice.future, slice.past]);

    useEffect(() => {
        if (isMobile()) {
            return;
        }
        if (instaSlice.display) {

            // document.body.style.overflow = 'unset';
            // document.body.style.backgroundColor = 'whitesmoke';
            Animated.timing(opacity.current, {
                toValue: 1,
                duration: 800,
                useNativeDriver: true
            }).start();
        } else {
            Animated.timing(opacity.current, {
                toValue: 0,
                duration: 300,
                useNativeDriver: true
            }).start();

        }

    }, [instaSlice]);



    const onProfileClick = (profile: InstaProfileINT) => {
        store.dispatch(setSelectedProfile(profile.key));
        // setSelectedProfile(profile);
    };
    const onCloseClick = () => {
        // setSelectedProfile(null);
        store.dispatch(setSelectedProfile(''));
    };
    const onCloseClickInsideModal = () => {
        // setImageClicked(null);
        store.dispatch(setSelectedImage(''));
    };


    const styles = StyleSheet.create({
        animatedViewContainer: {
            position: "absolute",
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,

        },
        mainContainer: {
            backgroundColor: 'whitesmoke',
            position: "absolute",
            zIndex: 5,
            width: "100%",
            height: "100%"
        },
        container: {
            // width: Platform.OS === 'android' || Platform.OS === 'ios' ? "100%" : 936,
            width: "100%",
            margin: "auto",
        }, overlay: {

            width: "100%",
            height: "100%",
            position: 'absolute',
            zIndex: 999999,

            backgroundColor: '#adadadcc'
        },
        closeButton: {
            // right: 0,
            position: "absolute",
            // marginRight: 10,
            right: 25,
            top: 20,
            zIndex: 999999999999

        },

        navInsideModal: {
            width: "86.8%",
            left: "6.6%"
        },
        modalOverlay: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            height: height,
            backgroundColor: 'rgba(0,0,0,0.5)'
        },
    });

    const onImagePressed = (image: InstaImage) => {
        // setImageClicked(image);
        store.dispatch(setSelectedImage(image.key));
    };
    const onSubmit = (input: string | boolean) => {
        if (input && typeof input === "string") {

            store.dispatch(setUserName(input));
        }

    };


    return (
        <>
            {
                instaSlice.display && !Game.rollback ?

                    <Animated.View style={[styles.animatedViewContainer, { opacity: opacity.current }]}>
                        {!instaSlice.userName ?
                            <PromptQuestionModal defaultValue={"Ben_69"} placeHolder={"Enter your username..."} onSubmit={(input) => onSubmit(input)}></PromptQuestionModal>
                            : <></>}
                        <InstaWelcomeScreen instaName={instaSlice.userName || `Ben_69`} instaProfiles={Object.keys(instaSlice.profiles).map(profile => (instaSlice.profiles[profile]))} onProfileClick={onProfileClick}></InstaWelcomeScreen>
                        {instaSlice.selectedProfile ?
                            <View style={styles.mainContainer}>
                                <InstaNavBar onCloseClick={onCloseClick}  ></InstaNavBar>
                                <ScrollView style={styles.container}>
                                    <InstaProfile profile={instaSlice.profiles[instaSlice.selectedProfile]}></InstaProfile>
                                    <InstaImages images={instaSlice.profiles[instaSlice.selectedProfile].images} onImagePressed={onImagePressed}></InstaImages>
                                </ScrollView>
                                {instaSlice.selectedImage ? <Modal
                                    animationType={isMobile() ? "slide" : "fade"}
                                    statusBarTranslucent
                                    transparent={true}
                                    visible={true}
                                >

                                    {/* <InstaNavBar onCloseClick={onCloseClickInsideModal} style={styles.navInsideModal} ></InstaNavBar> */}
                                    <View style={{
                                        width: width,
                                        height: width / 1.6 * 9 / 16,
                                        alignItems: isMobile() ? "baseline" : "center"
                                    }}>
                                        <TouchableWithoutFeedback onPress={() => onCloseClickInsideModal()}>
                                            <View style={styles.modalOverlay} />
                                        </TouchableWithoutFeedback>
                                        <InstaPost user={instaSlice.userName || ''} instaProfile={instaSlice.profiles[instaSlice.selectedProfile]} selectedImage={instaSlice.profiles[instaSlice.selectedProfile].images.filter(image => (image.key === instaSlice.selectedImage))[0]} ></InstaPost>

                                    </View>
                                </Modal> : <></>
                                }
                            </View>
                            :
                            <></>
                        }

                    </Animated.View> : <></>
            }
        </>
    );

};


